import type { PublicRoute } from "../../../routes/registry";
import OurWorkPage from "./OurWorkPage";

/** BR-WEB-004 — a new screen, so the prototype's title and description (no legacy page existed). */
const route: PublicRoute = {
  path: "/our-work",
  element: <OurWorkPage />,
  title: "Our work — outdoor living projects across the Darling Downs | Greatway Patios",
  description:
    "Patios, decks, opening roofs and screens we’ve designed and built for homes across Toowoomba and the Darling Downs.",
};

export default route;
